/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FocusEventHandler,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { IoMdRemove } from 'react-icons/io';
import Swal from 'sweetalert2';
import Input from '~/components/Input';
import { IModalityData } from '..';
import Toast from '~/utils/toast';
import { KrTrash } from '~/components/KoroIcons';
import { FaArrowsAltV } from 'react-icons/fa';

interface IModality {
  modality: IModalityData;
  sold?: boolean;
  value?: string;
  onFocus?: FocusEventHandler<any> | undefined;
  onBlur?: FocusEventHandler<any> | undefined;
  onChangeModality(value: string): void;
  onRemoveModality(): void;
}

const Modality: React.FC<IModality> = ({
  modality,
  sold,
  value,
  onFocus,
  onBlur,
  onChangeModality,
  onRemoveModality,
}) => {
  const [valueSelected, setValueSelected] = useState('');

  useEffect(() => {
    if (value) {
      setValueSelected(value);
    }
  }, [value]);

  const handleClickRemoveModality = useCallback(() => {
    if (valueSelected === '') {
      onRemoveModality();
      setValueSelected('');
    } else {
      Swal.fire({
        icon: 'warning',
        iconColor: '#ff6900',
        title: 'Gostaria de excluir a modalidade?',
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim',
        confirmButtonColor: '#ff6900',
        cancelButtonColor: '#B34A00',
        reverseButtons: true,
      }).then((e) => {
        if (e.isConfirmed) {
          Toast.fire({
            icon: 'success',
            iconColor: '#ff6900',
            title: 'Modalidade excluída com sucesso!',
          });
          onRemoveModality();
          setValueSelected('');
        }
      });
    }
  }, [onRemoveModality, valueSelected]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChangeModality(e.target.value);
      setValueSelected(e.target.value);
    },
    [onChangeModality]
  );

  const isOldModality = modality.id && modality.name;

  return (
    <div
      className={`bd-modality d-flex justify-content-between align-items-center p-2 mb-2 `}
    >
      <Input
        name={`modality-${modality.input_id}`}
        placeholder="Ex: Amador/Profissional"
        className="border-0 p-0 input-height"
        onFocus={onFocus}
        onBlur={onBlur}
        value={valueSelected}
        onChange={handleChange}
      />
      <FaArrowsAltV size={20} color="#8c8c8c" />
      <button
        type="button"
        disabled={!!(sold && isOldModality)}
        className={`${
          sold && isOldModality ? 'opacity-25 not-allowed' : ''
        } bg-transparent border-0 ms-4`}
        onClick={handleClickRemoveModality}
      >
        <KrTrash size={14} color="#B41717" className="svg-card" />
      </button>
    </div>
  );
};

export default Modality;
